/**
 * External Dependencies
 */
import { useMemo } from 'react';
import cx from 'classnames';

/**
 * Internal Dependencies
 */
import Icon from '@/common/icon/icon';
import { usePropertyLocationContext } from '@/common/contexts/use-property-location';

const FormRegisterStaysReviewProperties = ({
    properties,
    propertiesForReview,
    activePropertyId,
    onPropertyEdit,
    onPropertyRemove,
}) => {
    const { handleGeoCordinatesChange, updateMapToUserLocation } = usePropertyLocationContext();

    const propertiesText = useMemo(
        () =>
            propertiesForReview === 1
                ? `${propertiesForReview} property for review`
                : `${propertiesForReview} properties for review`,
        [propertiesForReview]
    );

    // The form-guest__propertis div should only be rendered if there are properties.
    const showPropertiesList = properties.length > 0;

    const handleOnAddressClick = (place) => {
        onPropertyEdit(place);
        handleGeoCordinatesChange(place);
    };

    const handleOnAddressRemove = (place) => {
        onPropertyRemove(place.place_id);
        updateMapToUserLocation();
    };

    return (
        <>
            {showPropertiesList && (
                <div className="form-guest__properties">
                    <p>{propertiesText}</p>

                    {!!properties.length && (
                        <ul>
                            {properties.map((place) => (
                                <li
                                    className={cx({
                                        'is-active': place.place_id === activePropertyId,
                                    })}
                                    key={place.place_id}
                                >
                                    <address onClick={() => handleOnAddressClick(place)}>
                                        <Icon name="location-dot" />

                                        {place.airbnb_address}
                                    </address>

                                    <button type="button" onClick={() => handleOnAddressRemove(place)}>
                                        Remove
                                    </button>
                                </li>
                            ))}
                        </ul>
                    )}
                </div>
            )}
        </>
    );
};

export default FormRegisterStaysReviewProperties;
